module.exports = __webpack_public_path__ + "static/media/frown.e3e4ac1d.svg";